import { render, staticRenderFns } from "./BrandsSearch.vue?vue&type=template&id=23e9a17c&"
import script from "./BrandsSearch.vue?vue&type=script&lang=js&"
export * from "./BrandsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports